module.exports = __webpack_public_path__ + "img/thumbnail_Quokka_m_normal.a3c7e2a7.png";